import { IGraphNode } from "@excitare/cli-config";
import { IServiceEnv } from "@excitare/cli-types";
import { PubSubEventData, PubSubEvents } from "@excitare/pubsub";
import path from "path";

import { pubSubServer } from "..";
import { ServiceInstance } from "../build";

import { LocalService } from "./service";

class LocalServices {
  async create(
    service: IGraphNode,
    preferredPort: number,
    io: SocketIO.Server,
    env: IServiceEnv,
    inspect: boolean
  ): Promise<LocalService> {
    const instance = new ServiceInstance(
      service.name,
      service.type,
      service.options.externals,
      service.options.bundle,
      service.options.icon || null,
      path.join(process.cwd(), service.from),
      io
    );

    const created = new LocalService(service, instance, preferredPort, io, env, inspect);
    await created.watch();
    // created.warm();
    return created;
  }

  serviceData = new Map<string, PubSubEventData.ClientInfo>();

  updateServiceData(
    name: string,
    data: Partial<PubSubEventData.ClientInfo>,
    update: boolean = false
  ): PubSubEventData.ClientInfo {
    let existing: PubSubEventData.ClientInfo | null = null;
    if (this.serviceData.has(name)) {
      existing = this.serviceData.get(name) as PubSubEventData.ClientInfo;

      this.serviceData.set(name, {
        ...existing,
        ...data
      });
    } else {
      this.serviceData.set(name, {
        ...data
      } as PubSubEventData.ClientInfo);
    }
    if (update) {
      if (existing != null && data.port === existing.port) {
        console.log("%s was updated but port remained %s", name, data.port);
      } else if (existing != null && data.port != null && data.port !== existing.port) {
        console.log("%s is now on port %s", name, data.port);
      }
      pubSubServer().emit(PubSubEvents.ClientInfo, this.serviceData.get(
        name
      ) as PubSubEventData.ClientInfo);
    }
    return this.serviceData.get(name) as PubSubEventData.ClientInfo;
  }

  byName(name: string): PubSubEventData.ClientInfo | null {
    if (this.serviceData.has(name)) {
      return this.serviceData.get(name) as PubSubEventData.ClientInfo;
    }
    return null;
  }
}

export const localServices = new LocalServices();
